define('ShippingDeliveryLocation.Result', [
    'Backbone',
    'jQuery',
    'underscore',
    'shippingdeliverylocation_result.tpl',
    'Store.Selector.Hours.Helper',
    'SC.Configuration',
    'Utils',
    'Utilities.CookieJar',
    'Store.Cookie',
    'Store.Profile.Service.Model'
], function ShippingDeliveryLocationResult(
    Backbone,
    jQuery,
    _,
    shippingDeliveryLocationResultTpl,
    HoursHelper,
    Configuration,
    Utils,
    CookieJar,
    StoreCookie,
    StoreProfileModel
) {
    'use strict';

    return Backbone.View.extend({
        template: shippingDeliveryLocationResultTpl,
        events: {
            'click [data-action="selectStore"]': 'selectStore'
        },
        initialize: function initialize(options) {
            this.profile = options.profile;

            this.listenTo(this.collection, 'sync', this.render);
        },
        getMessage: function getMessage() {
            var hasDeliver = this.getResultForDelivery(this.getMappedCollection());
            if (hasDeliver && hasDeliver.length) {
                return Configuration.get('ShippingDeliveryLocation.deliveryAvailable');
            }
            if (this.collection && this.collection.hasShippingAvailable && this.collection.hasShippingAvailable.zipCode) {
                return Configuration.get('ShippingDeliveryLocation.shippingAvailableButNotDelivery');
            }
            return Configuration.get('ShippingDeliveryLocation.notDeliveryAndShippingAvailable');
        },
        selectStore: function selectStore(e) {
            var $btn = jQuery(e.target);
            var id = $btn.data('id');
            var model = new StoreProfileModel({ internalid: id });
            model.save().done(function onChange() {
                StoreCookie.set(model.get('internalid'));
                CookieJar.setItem('needsCartCheck', 'true');
                window.location.reload();
            });
        },
        getResultForDelivery: function getResultForDelivery(collectionMapped) {
            return _.filter(collectionMapped, function filterCollection(location) {
                return location.hasServicesWithAvailableHours;
            });
        },
        getResultForPickup: function getResultForPickup(collectionMapped) {
            return _.filter(collectionMapped, function filterCollection(location) {
                return !location.hasServicesWithAvailableHours;
            });
        },

        getMappedCollection: function getMappedCollection() {
            var collectionLength = this.collection.length;
            var isGoogleDistanceEnabled = Configuration.get('store.enableGoogleCalculation');
            return this.collection.map(function eachResult(s, i) {
                return {
                    isLast: i === collectionLength - 1,
                    internalid: s.get('internalid'),
                    storeName: s.get('name'),
                    addressLine1: s.get('addr1') + ' ' + s.get('addr2'),
                    addressLine2: s.get('city') + ' ' + s.get('zip') + ' ' + s.get('state'),
                    showDistance: isGoogleDistanceEnabled && s.get('distance') && s.get('distance').text,
                    distanceText: s.get('distance') && s.get('distance').text,
                    directionsLink: 'https://www.google.com/maps/dir//' +
                        (s.get('addr1') + ', ' + s.get('city') + ', ' +
                            s.get('state') + ' ' + s.get('zip') + ', ' + s.get('country')
                        ).replace(/\|/g, ''),
                    isOpen: HoursHelper.isStoreOpen(s),
                    openHoursToday: HoursHelper.getTodayHoursString(s),
                    hasServicesWithAvailableHours: s.get('hasServicesWithAvailableHours')
                };
            });
        },
        getContext: function getContext() {
            var message = this.getMessage();
            var collectionMapped = this.getMappedCollection();
            var resultForPickup = this.getResultForPickup(collectionMapped);
            var resultForDelivery = this.getResultForDelivery(collectionMapped);
            return {
                showResults: this.collection.length > 0,
                showMessage: this.collection.length > 0,
                message: message,
                resultForPickup: resultForPickup,
                hasResultForPickup: resultForPickup && resultForPickup.length,
                resultForDelivery: resultForDelivery,
                hasResultForDelivery: resultForDelivery && resultForDelivery.length,
                showShippingAvailableButNotDeliveryMessage: this.collection.hasShippingAvailable &&
                    this.collection.hasShippingAvailable.zipCode &&
                    resultForPickup &&
                    resultForPickup.length,
                shippingAvailableButNotDeliveryMessage: Configuration.get('ShippingDeliveryLocation.shippingAvailableButNotDelivery'),
                notDeliveryAndShippingAvailableMessage: Configuration.get('ShippingDeliveryLocation.notDeliveryAndShippingAvailable'),
                deliveryAvailableMessage: Configuration.get('ShippingDeliveryLocation.deliveryAvailable')
            };
        }
    });
});
